import {Box} from "@mui/material";
import {useEffect, useState} from "react";
import {SCHOOL_DELIVERIES_ENDPOINT} from "../../utils/constants";
import BetweenDatePicker from "../../utils/betweenDates-picker";
import {BaseSearchBox} from "../search-box";
import {DeliveriesSortFilters} from "../../utils/constants-types";

export const DeliveriesSearch = (
    {
        data,
        setData,
        setLoading,
        setTotals,
        payload,
    }
) => {
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");

    useEffect(() => {
        if (startDate && endDate) {
            payload.start_date = startDate;
            payload.end_date = endDate;
        }
    }, [endDate, startDate]);

    const dateFilters = (
        <Box sx={{width: "100%", display: "flex", marginLeft: "25px"}}>
            <BetweenDatePicker
                startDate={startDate}
                endDate={endDate}
                setStartDate={setStartDate}
                setEndDate={setEndDate}
                label="Filters between dates"
            />
        </Box>
    );

    return BaseSearchBox({
        placeholder: "Enter inventory name or delivery person's name...",
        endpoint: SCHOOL_DELIVERIES_ENDPOINT,
        data: data,
        setData: setData,
        setTotals: setTotals,
        setIsLoading: setLoading,
        payload: payload,
        otherFilters: dateFilters,
        sortFilters: DeliveriesSortFilters,
    });
};
